import React from 'react'
import './Services.css';

import { TiTick } from "react-icons/ti";
import { GrVmMaintenance } from "react-icons/gr";
import { GrHostMaintenance } from "react-icons/gr";
const features = [
    {
        icon: <TiTick />,
        title: "Calibration",
        text: "NABL accredited calibration of Temperature and electrical parameters",
    },
    {
        icon: <GrHostMaintenance />,
        title: "Installation & Commissioning",
        text: "Team of well trained and experienced engineers to complete the jobs",
    },

     {
        icon: <GrVmMaintenance />,
        title: "Annual Maintenance Contract",
        text: "Maintenance contract for PLC and DCS Products ",


    },
];
export const Services = () => {
    return (
        <div className=" mt-2 py-2 text-center servicemain">
            <h1 className='title-head-Services'>Services</h1>
            <div className="title-decor d-flex justify-content-center align-items-center">
                <div className="line-Services"></div>
                <div className="dots mx-2">
                    <span></span><span></span><span></span>
                </div>
                <div className="line-Services"></div>
            </div>
            <div className="feature-container">
                {features.map((feature, index) => (
                    <div className="feature-card" key={index}>
                        <div className="feature-icon">{feature.icon}</div>
                        <h3 className="feature-title">{feature.title}</h3>
                        <p className="feature-text">{feature.text}</p>
                    </div>
                ))}
            </div>

        </div>
    )
}
